
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chats",
      function () {
        return require("private-next-pages/chats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chats"])
      });
    }
  